var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8917 1.30371L30.6423 10.1634L25.3389 30.9932L39.7415 6.40011C39.8229 6.26251 39.8875 6.11595 39.9347 5.96299C39.9709 5.84715 39.9929 5.7281 40 5.60714V5.49642C39.9838 3.80743 37.2207 2.30405 32.8917 1.30371Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2084 0.333435C5.51987 1.09633 0.0226171 3.11876 0 5.48872V5.60008C0.0200323 5.88104 0.110501 6.15369 0.261066 6.39241L19.9767 40L14.9958 10.8296L13.2084 0.333435Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4513 0.215043L23.1987 10.9333L21.1508 20.6967L19.558 11.0005L17.7706 0.0371206C18.5027 0.0147202 19.2433 0 19.9922 0C21.8843 0.00768012 23.7156 0.0812813 25.4513 0.215043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaLogo);
export default __webpack_public_path__ + "static/media/vita-logo.8cd94082751feb5525161d295029091b.svg";
export { ForwardRef as ReactComponent };